export var libConfig = {
    tag: 'data-slide-toggle',
    values: {
        hidden: 'hidden',
        visible: 'shown',
    },
};
//# sourceMappingURL=config.js.map